// Test IDs for the history list (Phase 05).
export const HISTORY = {
    root: 'history-root',
    list: 'history-list',
    empty: 'history-empty',
    item: 'history-item', // -{session_id}
    itemLink: 'history-item-link', // -{session_id}
    headerLink: 'app-header-history-link',
};
